var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.75,
    height: 14,
    viewBox: "0 0 6.75 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299",
    transform: "translate(-355 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_121",
    "data-name": "Polygon 121",
    d: "M2.5,1.549a1,1,0,0,1,1.743,0L5.912,4.51A1,1,0,0,1,5.04,6H1.71A1,1,0,0,1,.838,4.51Z",
    transform: "translate(355 252)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_120",
    "data-name": "Polygon 120",
    d: "M2.5,1.549a1,1,0,0,1,1.743,0L5.912,4.51A1,1,0,0,1,5.04,6H1.71A1,1,0,0,1,.838,4.51Z",
    transform: "translate(361.75 266) rotate(180)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSort);
export default __webpack_public_path__ + "static/media/arrow-sort.56addc08f52518db68214a3c92f93e84.svg";
export { ForwardRef as ReactComponent };